import { Button } from "@mui/material";
import TextInput from "components/forms/TextInput";
import { useSnackbar } from "notistack";
import { useForm } from "react-hook-form";
import { useBackendError } from "services/hooks";
import { changePassword } from "services/user";
import { useAppSelector } from "store/hooks";

const Security = (props:any) => {

  const {
    control,
    handleSubmit,
    formState: { errors },
    watch,
  } = useForm();
  const { handleRequestError } = useBackendError();
  const { enqueueSnackbar } = useSnackbar();
  const { jwt, user } = useAppSelector((state) => state.app);

  const submit = async (form) => {
    const { password } = form;
    try {
      await changePassword(jwt!,password,user?.id!);
      enqueueSnackbar("Success! You password has been updated.", {
        variant: "success",
        anchorOrigin: {
          vertical: "top",
          horizontal: "center",
        },
      });
    } catch(err) {
      handleRequestError(err);
    }
  }
  
  return (
    <div className="row justify-content-center">
      <div className="col-xl-6 col-lg-12">
        <form onSubmit={handleSubmit(submit)}>
          <TextInput
            control={control}
            name="password" 
            label="Password"
            errors={errors}
            type="password"
            rules={{
              required: "This field is required",
              minLength: {
                value: 5,
                message: "Password must have at least 5 characters.",
              },
            }}
          />
          <TextInput
            control={control}
            name="confirm_password" 
            label="Confirm Password"
            errors={errors}
            type="password"
            rules={{
              validate: (value) => {
                return (
                  value === watch("password") || "Your passwords must match."
                );
              },
            }}
          />
          <Button type="submit" variant="contained" size="small">Submit</Button>
        </form>
      </div>
    </div>
  )
};

export default Security;
